import React from 'react';
import {makeStyles} from "@material-ui/core/styles";
import Typography from '@material-ui/core/Typography';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    textInput: {
        width: '100%',
    },
}));

const FieldStaticText = ({scheme}) => {
    const classes = useStyles();
    const { i18n } = useTranslation();
    const currentLang = i18n.language;
    return (
        <React.Fragment>
            <Typography variant="subtitle1">
                {currentLang === 'en' ? scheme.label_en : scheme.label}
            </Typography>
        </React.Fragment>
    );
};
export default FieldStaticText;